import gql from 'graphql-tag'

export default gql`
mutation createBatchTrackingKerry($labelIds: [String!]) {
  createBatchTrackingKerry(labelIds: $labelIds) {
    _id
    sendHook
  }
}
`


// WEBPACK FOOTER //
// ./src/graphql/mutations/CreateBatchTrackingKerry.js